import s from "./Logo.module.scss";

import { NavLink } from "react-router-dom";

const Logo = (props) => {
	return (
		<NavLink className={s.logo} to={"/"}>
			<svg
				width="223"
				height="36"
				viewBox="0 0 223 36"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g id="logo">
					<g
						id="SkyFitnessPro"
						style={{
							fill: props.fill === "white" ? "white" : "black",
						}}
					>
						<path d="M39.4001 12.012C39.4001 14.784 40.8281 16.436 42.6761 17.752L45.0561 19.46C46.3161 20.356 47.2401 21.392 47.2401 22.96C47.2401 24.36 46.3161 25.2 44.8601 25.2C43.4321 25.2 42.4801 24.164 42.4801 22.484V21H39.1201V22.68C39.1201 26.292 41.6961 28.28 44.8601 28.28C48.0241 28.28 50.6001 26.376 50.6001 22.54C50.6001 19.852 49.1161 18.2 47.2961 16.884L44.8321 15.12C43.6561 14.28 42.7601 13.412 42.7601 12.012C42.7601 10.584 43.6001 9.79997 44.8321 9.79997C46.1481 9.79997 46.9601 10.612 46.9601 12.404V13.72H50.3201V12.32C50.3201 8.53997 47.8841 6.71997 44.8321 6.71997C41.8361 6.71997 39.4001 8.23197 39.4001 12.012Z" />
						<path d="M57.47 6.99997H54.11V28H57.47V20.636L63.49 28H67.69L61.166 20.356L67.326 14H62.902L57.47 20.104V6.99997Z" />
						<path d="M77.138 29.456L82.43 14H79.07L75.542 24.78L72.042 14H68.682L73.946 29.428C73.134 31.388 72.154 32.312 70.586 32.312C69.914 32.312 69.27 32.172 68.738 32.004V34.972C69.27 35.14 70.082 35.28 70.894 35.28C74.45 35.28 75.962 32.9 77.138 29.456Z" />
						<path d="M89.4493 28V19.32H94.8813V16.24H89.4493V10.08H95.7213V6.99997H86.0893V28H89.4493Z" />
						<path d="M100.47 11.2C101.702 11.2 102.57 10.276 102.57 9.09997C102.57 7.89597 101.702 6.99997 100.47 6.99997C99.266 6.99997 98.37 7.89597 98.37 9.09997C98.37 10.276 99.266 11.2 100.47 11.2ZM102.15 28V14H98.79V28H102.15Z" />
						<path d="M110.823 23.212V16.94H114.463V14H110.823V9.79997H107.463V14H105.223V16.94H107.463V23.436C107.463 27.188 109.479 28.28 112.251 28.28C113.063 28.28 113.959 28.112 114.463 27.944V24.948C113.987 25.116 113.399 25.2 112.923 25.2C111.467 25.2 110.823 24.584 110.823 23.212Z" />
						<path d="M127.334 20.3V28H130.694V19.628C130.694 15.68 128.454 13.72 125.486 13.72C123.75 13.72 122.322 14.532 121.454 16.016V14H118.094V28H121.454V20.3C121.454 17.948 122.574 16.66 124.394 16.66C126.214 16.66 127.334 17.948 127.334 20.3Z" />
						<path d="M147.884 22.12C147.912 21.756 147.94 21.392 147.94 21C147.94 16.716 145 13.72 140.996 13.72C136.992 13.72 134.052 16.716 134.052 21C134.052 25.284 136.992 28.28 140.996 28.28C144.3 28.28 146.736 26.712 147.576 23.8H143.936C143.488 24.78 142.62 25.34 141.136 25.34C139.064 25.34 137.72 24.164 137.356 22.12H147.884ZM140.996 16.66C142.956 16.66 144.244 17.78 144.608 19.74H137.384C137.748 17.78 139.036 16.66 140.996 16.66Z" />
						<path d="M162.484 23.968C162.484 18.2 154.252 20.496 154.252 17.808C154.252 16.912 155.092 16.38 156.352 16.38C157.724 16.38 158.732 17.276 158.732 18.452H162.232C162.232 15.792 159.712 13.72 156.352 13.72C153.244 13.72 150.864 15.344 150.864 17.948C150.864 23.66 159.012 21.14 159.012 24.108C159.012 25.144 158.172 25.648 156.772 25.648C155.26 25.648 154.112 24.892 154.112 23.38H150.612C150.612 26.488 153.272 28.28 156.772 28.28C160.048 28.28 162.484 26.628 162.484 23.968Z" />
						<path d="M177.153 23.968C177.153 18.2 168.921 20.496 168.921 17.808C168.921 16.912 169.761 16.38 171.021 16.38C172.393 16.38 173.401 17.276 173.401 18.452H176.901C176.901 15.792 174.381 13.72 171.021 13.72C167.913 13.72 165.533 15.344 165.533 17.948C165.533 23.66 173.681 21.14 173.681 24.108C173.681 25.144 172.841 25.648 171.441 25.648C169.929 25.648 168.781 24.892 168.781 23.38H165.281C165.281 26.488 167.941 28.28 171.441 28.28C174.717 28.28 177.153 26.628 177.153 23.968Z" />
						<path d="M185.151 28V20.16H187.923C191.367 20.16 193.831 18.032 193.831 14.14V12.74C193.831 8.98797 191.367 6.99997 187.923 6.99997H181.791V28H185.151ZM187.643 10.08C189.379 10.08 190.471 10.892 190.471 13.02V13.86C190.471 16.156 189.379 17.08 187.643 17.08H185.151V10.08H187.643Z" />
						<path d="M200.558 14H197.198V28H200.558V20.86C200.558 18.508 202.014 17.22 204.506 17.22C205.066 17.22 205.57 17.304 205.962 17.444V13.776C205.794 13.72 205.514 13.72 205.262 13.72C203.218 13.72 201.566 14.616 200.558 16.268V14Z" />
						<path d="M214.938 28.28C219.026 28.28 222.078 25.284 222.078 21C222.078 16.716 219.026 13.72 214.938 13.72C210.85 13.72 207.798 16.716 207.798 21C207.798 25.284 210.85 28.28 214.938 28.28ZM214.938 25.2C212.782 25.2 211.158 23.52 211.158 21C211.158 18.48 212.782 16.8 214.938 16.8C217.094 16.8 218.718 18.48 218.718 21C218.718 23.52 217.094 25.2 214.938 25.2Z" />
					</g>
					<g id="Logo">
						<g id="Logo_2">
							<g id="Triangles">
								<path
									id="Left Triangle"
									d="M3.68844 28.4581C1.54195 29.698 0 28.6648 0 26.827C0 24.8705 0 19.0003 0 19.0003C0 19.0003 0 13.1301 0 11.1737C0 9.33591 1.54099 8.30269 3.68844 9.54255C7.03156 11.4731 17.06 17.2668 17.06 17.2668C18.3934 18.037 18.3934 19.9628 17.06 20.7329C17.06 20.7338 7.03156 26.5275 3.68844 28.4581Z"
									fill="#00C1FF"
								/>
								<path
									id="Right Triangle"
									d="M14.7265 28.4574C12.58 29.6972 11.0381 28.664 11.0381 26.8262C11.0381 24.8698 11.0381 18.9996 11.0381 18.9996C11.0381 18.9996 11.0381 13.1294 11.0381 11.173C11.0381 9.33518 12.5791 8.30196 14.7265 9.54182C17.996 11.4303 27.8044 17.0968 27.8044 17.0968C29.2689 17.9425 29.2689 20.0567 27.8044 20.9024C27.8035 20.9024 17.996 26.5689 14.7265 28.4574Z"
									fill="#BCEC30"
								/>
							</g>
							<mask
								id="mask0_26_1313"
								style={{ maskType: "alpha" }}
								maskUnits="userSpaceOnUse"
								x="11"
								y="9"
								width="18"
								height="20"
							>
								<path
									id="Mask"
									d="M14.7265 28.4574C12.58 29.6972 11.0381 28.664 11.0381 26.8262C11.0381 24.8698 11.0381 18.9996 11.0381 18.9996C11.0381 18.9996 11.0381 13.1294 11.0381 11.173C11.0381 9.33518 12.5791 8.30196 14.7265 9.54182C17.996 11.4303 27.8044 17.0968 27.8044 17.0968C29.2689 17.9425 29.2689 20.0567 27.8044 20.9024C27.8035 20.9024 17.996 26.5689 14.7265 28.4574Z"
									fill="#6FE4FF"
								/>
							</mask>
							<g mask="url(#mask0_26_1313)">
								<g id="Blur" filter="url(#filter0_f_26_1313)">
									<path
										d="M3.68892 28.4585C1.54244 29.6983 0.000488281 28.6651 0.000488281 26.8273C0.000488281 24.8709 0.000488281 19.0007 0.000488281 19.0007C0.000488281 19.0007 0.000488281 13.1305 0.000488281 11.1741C0.000488281 9.33628 1.54148 8.30306 3.68892 9.54292C7.03205 11.4735 17.0605 17.2672 17.0605 17.2672C18.3939 18.0373 18.3939 19.9631 17.0605 20.7333C17.0605 20.7342 7.03205 26.5279 3.68892 28.4585Z"
										fill="#99D100"
									/>
								</g>
							</g>
						</g>
					</g>
				</g>
				<defs>
					<filter
						id="filter0_f_26_1313"
						x="-1.46075"
						y="7.53986"
						width="20.9825"
						height="22.9216"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="BackgroundImageFix"
							result="shape"
						/>
						<feGaussianBlur
							stdDeviation="0.730621"
							result="effect1_foregroundBlur_26_1313"
						/>
					</filter>
				</defs>
			</svg>
		</NavLink>
	);
};

export default Logo;
